import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import ProdIOOExoCMNEditor from './ProdIOOExoCMNEditor';
import {CmnStoneSearch} from '../../../../cmn/snippet/Index';
import { UiGridColOne,UiCol } from "../../../../../library/layout/Index";

const ProdIOOExoStoneEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ actionParam:{actionType: 'addPlanItem'},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '250px' }}
            formStyle={{ width: '550px', height:"400px" }} formTitle={<SarasTrans value="Stone Editor" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <CmnStoneSearch formObject={formObject} rowKey="" viewData={viewData} masterKeys={masterKeys} {...restProps} />
                        </li>
                        <ProdIOOExoCMNEditor {...props} />
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(ProdIOOExoStoneEditor, "prodIOPlan", "prodEOOutputGroup,prodIOEOGroup")